import { AxiosError } from 'axios';

// Robust check for error status and message
// Fallback to an unknown status and generic message if specific details are not available
export const getErrorMessage = (
  error: AxiosError | unknown,
  fallbackMessage: string | null = null,
) => {
  return (
    error?.response?.data?.message ||
    error?.data?.message ||
    error?.message ||
    fallbackMessage ||
    'An unexpected error occurred. Please try again.'
  );
};

export const getErrorStatus = (error: AxiosError | unknown) =>
  error?.response?.status || error?.status || 'unknown';
